export const RouteNames = {
  card: '/card',
  faq: '/faq',
  legal: '/legal',
};
